import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import {
  BaseText,
  Heading,
  ChipStatus,
  ChipContext
} from '@warrenbrasil/nebraska-web';
import { ProgressiveImage } from '@/modules/common/components/ProgressiveImage';
import { Money } from '@/modules/common/components/Money';

import { IPortfolioList } from '@/types/models/Portfolio';

interface Emits {
  (event: 'click', id: string): void;
}
interface Props {
  portfolio: IPortfolioList;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'PortfolioCardV2',
  props: {
    portfolio: null
  },
  emits: ["click"],
  setup(__props: any, { emit: emits }: { emit: ({
  (event: 'click', id: string): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  portfolio: IPortfolioList;
};





const isPortfolioDisabled = computed(() => {
  return !props.portfolio.enabled || false;
});

const classes = computed(() => {
  return {
    progressiveImage: {
      'portfolio-card__background': true,
      'portfolio-card__background--inactive':
        props.portfolio.isInactive || isPortfolioDisabled.value
    },
    card: {
      'portfolio-card__card': true,
      'portfolio-card__card--disabled': isPortfolioDisabled.value
    },
    content: {
      'portfolio-card__content': true,
      'portfolio-card__content--has-message': props.portfolio.message
    }
  };
});

function handleClick() {
  if (isPortfolioDisabled.value) {
    return;
  }

  emits('click', props.portfolio.id);
}

return { __sfc: true,emits, props, isPortfolioDisabled, classes, handleClick, NebraskaColors, BaseText, Heading, ChipStatus, ChipContext, ProgressiveImage, Money }
}

})